import type { BaseResponse, PaginatedResponse } from './base';

export enum SystemAnnouncementCategory {
  RELEASE_NOTE = 'releaseNote',
  ANNOUNCEMENT = 'announcement',
  GUIDELINE = 'guideline',
}

export const SystemAnnouncementCategoryList = [
  SystemAnnouncementCategory.RELEASE_NOTE,
  SystemAnnouncementCategory.ANNOUNCEMENT,
  SystemAnnouncementCategory.GUIDELINE,
];

export enum SystemAnnouncementStatus {
  DRAFT = 'draft',
  ACTIVE = 'active',
}

export interface SystemAnnouncement {
  id: number;
  uid: string;
  category: SystemAnnouncementCategory;
  status: SystemAnnouncementStatus;
  title: string;
  body: string;
  created_at: string;
}

export interface SystemAnnouncementListResponse extends PaginatedResponse<SystemAnnouncement> {}

export interface SystemAnnouncementResponse extends BaseResponse<SystemAnnouncement> {}

export interface SystemAnnouncementLatest {
  latest_created_at: string;
}

export interface SystemAnnouncementLatestResponse extends BaseResponse<SystemAnnouncementLatest | null> {}

export interface SystemAnnouncementSubscription {
  recipient_emails: string[];
}

export interface SystemAnnouncementSubscriptionResponse extends BaseResponse<SystemAnnouncementSubscription> {}
